mutation CompanyCorporateYearDelete($input: CompanyCorporateYearDeleteInput!) {
  companyCorporateYearDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
